export default __webpack_public_path__ + "static/media/photo4.2654e310.svg";